import { toast } from 'react-toastify';

import { fetchSuperlogicaList, createNewEstablishment as createNewEstablishmentRequest } from './services';
import { setSuperlogicaList, handleLoading } from './actions';

export const loadSuperlogicaList = userId => dispatch => {
  return fetchSuperlogicaList(userId)
    .then(({ data }) => dispatch(setSuperlogicaList(data)))
    .catch(() => dispatch(setSuperlogicaList([])));
}

export const createNewEstablishment = params => dispatch => {
  dispatch(handleLoading(true));

  return createNewEstablishmentRequest(params)
    .then(async ({ data }) => {
      toast.success('Estabelecimento criado com sucesso!');
      return Promise.resolve(data);
    })
    .catch(error => {
      toast.error('Houve um erro ao criar o estabelecimento.');
      return Promise.reject(error);
    })
    .finally(() => dispatch(handleLoading(false)));
}